import _default from './List';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/List/index.js
// module id = 1759
// module chunks = 0